import { render, staticRenderFns } from "./SideRightToken.vue?vue&type=template&id=53ed9c27&scoped=true"
import script from "./SideRightToken.vue?vue&type=script&lang=js"
export * from "./SideRightToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ed9c27",
  null
  
)

export default component.exports